import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputGroupModule } from '@forms/input-group/input-group.module';
import { NgStackFormsModule } from '@ng-stack/forms';
import { TagsFieldComponent } from './tags-field.component';

@NgModule({
  declarations: [TagsFieldComponent],
  imports: [CommonModule, InputGroupModule, NgStackFormsModule],
  exports: [TagsFieldComponent],
})
export class TagsFieldModule {}
